<template>
    <div class="worldcup--general-section style-2">
        <a class="back" @click="ClickHideComponent" data-toggle="modal" href="javascript:void(0)">
            <img src="/assets/img/icon-back.svg" alt="back"/>
        </a>
        <b-tabs class="tab-modal">
            <b-tab title="Vòng quay World Cup" active>
                <div class="worldcup--box-tab top-rancing">
                    <div class="top-rancing__thumb">
                        <img :src="`${$store.state.mapDomain.STATIC_URL}/assets/img/event/worldcup/top-rancing-mb.png`" />
                    </div>
                    <TopRancing class="mobile" />
                </div>
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import TopRancing from '~/components/event/worldcup/top-rancing.vue';

export default {
    components: {
        TopRancing
    },
    methods: {
        ClickHideComponent() {
            this.$emit('hideComponent');
        }
    }
};
</script>
